<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card>
          <div class="bd-example">
            <dl class="row">
              <dt class="col-sm-3">{{$t('page.generic.code')}}</dt>
              <dd class="col-sm-9">{{companyData.code}}</dd>
              <dt class="col-sm-3">{{$t('page.generic.name')}}</dt>
              <dd class="col-sm-9">{{companyData.label}}</dd>
              <dt class="col-sm-3">{{$t('page.generic.description')}}</dt>
              <dd class="col-sm-9">{{ companyData.description }}</dd>
              <dt class="col-sm-3">{{$tc('page.generic.state', 1)}}</dt>
              <dd class="col-sm-9">
                <b-badge :variant="getBadge(companyData.active)">{{activeDesc(companyData.active)}}</b-badge>
              </dd>
            </dl>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <router-link class="btn btn-primary float-right" role="button"
                           :to="{path: `/company/edit/${companyData.id}`}" push>
                {{ $t('actions.edit') }}
              </router-link>
            </div>
          </div>
        </b-card>
        <b-card :title="$t('card.companyModel.title')"
                v-if="companyModels.length">
          <b-table :stacked="stacked" :dark="dark" :hover="hover" :striped="striped" :bordered="bordered"
                   :small="small"
                   :fixed="fixed"
                   responsive="sm" :items="companyModels" :fields="fields"
                   :current-page="currentPage"
                   :per-page="perPage">
            <template slot="model.code" slot-scope="data">
              <router-link :to="{name: 'modelShowRoute', params:{id: data.item.model.id}}">
                {{ data.item.model.code }}
              </router-link>
            </template>
            <template slot="mandatory" slot-scope="data">
              <b-badge :variant="data.item.mandatory ? 'success' : 'danger'">{{mandatoryDesc(data.item.mandatory)}}
              </b-badge>
            </template>
            <template slot="model.description" slot-scope="data">
              <span>{{data.item.model.description}}</span>
            </template>
            <template slot="categories" slot-scope="data">
              <b-badge v-for="category in data.item.model.categories" :key="category.id" :variant="`warning`"
                       class="mx-1">
                {{category.code}}
              </b-badge>
            </template>
          </b-table>
          <nav>
            <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev"
                          next-text="Next" hide-goto-end-buttons/>
          </nav>

        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import miniToastr from 'mini-toastr' //ES6
  import PageTitle from '../../components/PageTitle'
  import CompanyService from "@/services/CompanyService"
  import i18n from '@/config/i18n'

  const companyService = CompanyService.build();

  export default {
    name: 'CompanyShow',
    props: {
      id: {
        required: true
      },
      stacked: {
        type: String,
        default: 'sm'
      },
      hover: {
        type: Boolean,
        default: true
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      },
      perPage: {
        type: Number,
        default: 7
      },
      dark: {
        type: Boolean,
        default: false
      },
      fields: {
        type: [Array, Object],
        default: () => [
          {
            key: 'mandatory',
            label: i18n.t('page.generic.mandatory'),
            sortable: true
          },
          {
            key: 'model.code',
            label: i18n.t('page.generic.code'),
            sortable: true
          },
          {
            key: 'model.modelVersion',
            label: i18n.t('page.generic.version'),
            formatter: 'versionFormatter',
            sortable: true
          },
          {
            key: 'model.modelFormat',
            label: i18n.tc('page.generic.format', 1),
            sortable: true
          },
          {
            key: 'model.description',
            label: i18n.t('page.generic.description'),
            sortable: true
          },
          {
            key: 'categories',
            label: i18n.tc('title.categories', 1),
            sortable: false
          },
        ]
      },

    },
    components: {
      PageTitle
    },
    data() {
      return {
        deleteModal: false,
        companyData: {},
        companyModels: [],
        currentPage: 1,
      }
    },
    computed: {
      totalRows: function () {
        return this.getRowCount()
      },
    },
    created() {
      this.fetchData();
      miniToastr.init();
      miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'})
    },
    methods: {
      getRowCount: function () {
        return this.companyModels.length
      },
      async fetchData() {
        this.companyData = await companyService.read(this.id);
        const models = await companyService.modelsByCode(this.companyData.code);
        this.companyModels = models.sort((a, b) => a.orderModel - b.orderModel);
      },
      mandatoryDesc: function (value) {
        return value ? i18n.tc('page.generic.yes') : i18n.tc('page.generic.no')
      },
      versionFormatter(value) {
        return `V-${value < 10 ? '0' + value : value}`
      },
      getBadge(active) {
        return active ? 'success' : 'danger'
      },
      activeDesc: function (value) {
        return value ? i18n.t('page.generic.enabled') : i18n.t('page.generic.disabled')
      },
    }
  }
</script>

<style type="text/scss" scoped>
  a {
    text-decoration: none;

    &:hover {
      text-decoration: none;
    }
  }
</style>
